import { getHeaderTabMenu, getAsideTabMenu } from '@/api/tabs'
import store from '../index';
// 导航模块 tab && aside
const tabsModule = {
  namespaced: true,
  state() {
    return {
      isNavTipsShow: false,
      isAsideShow: false,
      isHeaderShow: false,
      headerTabMenu: [],
      asideTabMenu: [],
      routePath: null,
      activeId: null
    }
  },
  mutations: {
    changeNavShow(state) {
      state.isNavTipsShow = !state.isNavTipsShow
    },
    changeAsideShow(state, bool) {
      state.isAsideShow = bool
    },
    changeHeaderShow(state, bool) {
      state.isHeaderShow = bool
    },
    changeRoutePath(state, path) {
      state.routePath = path
    },
    getHeaderTabMenuData(state, headerMenu) {
      state.headerTabMenu = headerMenu
    },
    getAsideTabMenuData(state, asideMenu) {
      state.asideTabMenu = asideMenu
    },
    SET_ACTIVE_ID(state, id) {
      state.activeId = id
    }
  },
  actions: {


    async asyncGetHeaderTabMenuData({ commit }) {
      const { data: res } = await getHeaderTabMenu()
            if (res.code !== 200) {
        return Promise.reject(new Error('获取数据失败！'))
      } else {
        const filteredMenu = res.data // 移除过滤，显示所有菜单
        commit('getHeaderTabMenuData', filteredMenu)
      }
    },

async asyncGetAsideTabMenuData({ commit }, pid) {
  try {
    const { data: res } = await getAsideTabMenu(pid)
    
    if (res.code !== 200) {
      // 这里的错误提示可以更通用一些
      return Promise.reject(new Error(res.message || '获取菜单数据失败！'))
    }

    // 直接使用后端返回的数据
    let menuData = res.data || []

    // 逻辑处理：如果后端返回的 children 是对象格式，或者需要统一排序
    menuData.forEach(item => {
      if (item.children) {
        // 如果后端返回的是对象，转成数组；如果是数组，则直接使用
        const childrenArray = Array.isArray(item.children) 
          ? item.children 
          : Object.values(item.children);

        // 统一按 sort 字段排序（增强健壮性）
        item.children = childrenArray.sort((a, b) => (a.sort || 0) - (b.sort || 0));
      }
    });

    commit('getAsideTabMenuData', menuData)
    return menuData // 返回数据方便组件调用时做后续处理
    
  } catch (error) {
    console.error('获取菜单数据异常:', error);
    return Promise.reject(error)
  }
}
  },
  getters: {
    getActiveId: (state) => state.activeId
  }
}
export default tabsModule
